// src/pages/GenericAiSearch.js
import React, { useState } from 'react';
import "./App.css";

const App = () => {
  const [question, setQuestion] = useState('');
  const [results, setResults] = useState([]);
  const [rawHtml, setRawHtml] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedWebhook, setSelectedWebhook] = useState('seek');

  const webhookUrls = {
    seek: 'https://n8n.margue.net:5678/webhook/c56eb6e9-a718-4f13-9233-0141a5e94b0f',
    travel: 'https://n8n.margue.net:5678/webhook/ee5862b8-f122-4207-b050-c0fd6cd125a6',
    misc: 'https://n8n.margue.net:5678/webhook/87b9f2ab-592f-4ccc-82a8-e0419b69ac21',
  };

  const webhookTitles = {
    seek: "Seek Search",
    Travel: "Travel Assistant",
    misc: "Miscellaneous Agent"
  };

  const fetchFromAgent = async () => {
    setLoading(true);
    setResults([]);
    setRawHtml('');

    try {
      const response = await fetch(webhookUrls[selectedWebhook], {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ question })
      });

      const data = await response.json();
      const output = data?.[0]?.output || data?.output || '';
      setRawHtml(formatTextToHtml(output));

      const parsedResults = await parseDynamicOutput(output);
      setResults(parsedResults);
    } catch (err) {
      console.error('Error:', err);
    }

    setLoading(false);
  };

  const formatTextToHtml = (text) => {
    return text
      .replace(/\n\n/g, '<br><br>')
      .replace(/\n/g, '<br>')
      .replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
  };

  const parseDynamicOutput = async (text) => {
    const linkRegex = /\[(.*?)\]\((.*?)\)/g;
    const matches = [...text.matchAll(linkRegex)];

    const enriched = await Promise.all(matches.map(async ([, title, url]) => {
      let image = '';
      try {
        const valid = !url.includes('list-') && url.length < 150;
        if (valid) {
          const microRes = await fetch(`https://api.microlink.io/?url=${encodeURIComponent(url)}&screenshot=true&embed=card&meta=true`);
          const preview = await microRes.json();
          image = preview?.data?.screenshot?.url || preview?.data?.image?.url || '';
        }
      } catch (err) {
        console.warn(`No preview from Microlink for ${url}`, err);
      }

      if (!image) {
        image = '/missing.jpg';
      }

      return { title, url, image };
    }));

    return enriched;
  };

  return (
    <div className="ai-search-container">
      <h1>{webhookTitles[selectedWebhook]}</h1>

      <div className="webhook-selector">
        <label htmlFor="webhook">Choose webhook: </label>
        <select
          id="webhook"
          value={selectedWebhook}
          onChange={(e) => setSelectedWebhook(e.target.value)}
        >
          <option value="seek">Seek</option>
          <option value="Travel">Travel</option>
          <option value="misc">Misc</option>
        </select>
      </div>

      <textarea
        className="question-input"
        rows={4}
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
        placeholder="Ask anything..."
      />

      <button
        onClick={fetchFromAgent}
        className="ask-button"
        disabled={loading}
      >
        {loading ? 'Thinking...' : 'Ask'}
      </button>

      {rawHtml && (
        <div className="html-output" dangerouslySetInnerHTML={{ __html: rawHtml }} />
      )}

      <div className="results-grid">
        {results.map((res, idx) => (
          <a
            href={res.url}
            key={idx}
            target="_blank"
            rel="noopener noreferrer"
            className="result-card"
          >
            {res.image && <img src={res.image} alt={res.title} className="result-image" />}
            <div className="card-content">
              <h2>{res.title}</h2>
              <p>{res.url}</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default App;
